module.exports = __webpack_public_path__ + "img/exemple4.fb5db2d7.png";